import { Text } from '@backstage/ui';

/** Danger-coloured validation message shown beneath a form field. */
export const FieldError = ({ message }: { message?: string }) =>
  message ? (
    <Text variant="body-small" color="danger">
      {message}
    </Text>
  ) : null;
